import React,{useState} from "react";
import {linkedInImage,mailImage,twitterImage} from "./Images";

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

const ContactMe = () => {
    const [formState, setFormState] = useState({ name: "", email: "", message: "" });
    const [formSuccess, setFormSuccess] = useState(false);
    const handleSubmit = e => {
        e.preventDefault();
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "contact", ...formState })
        })
            .then(() =>{ 
                setFormSuccess(true);
                setFormState({ name: "", email: "", message: "" })
            })
            .catch(error => alert(error));

    };
    const handleChange = e =>{ 
        setFormSuccess(false);
        setFormState({ ...formState, [e.target.name]: e.target.value })
    };
    const { name, email, message } = formState;
    return (
        <div className="sectionDiv contactMe" id="contactMe">
        <div className="headerDiv">
            <div className="heading2"><i className="fa fa-paper-plane"></i>Contact me
            </div>
        </div>
        <div className="sectionBody contactBody">
            <div className="formDiv">
                <div>
                    <form data-netlify="true" name="contact" onSubmit={handleSubmit}>
                        <p>
                            <label>
                                <input type="text" placeholder="name" name="name" value={name} onChange={handleChange} required />
                            </label>
                        </p>
                        <p>
                            <label>
                                <input type="email" placeholder="email" name="email" value={email} onChange={handleChange} required />
                            </label>
                        </p>
                        <p>
                            <label>
                                <textarea name="message" placeholder="message" value={message} onChange={handleChange} required />
                            </label>
                        </p>
                        <p className="successMsg">
                            {formSuccess && "Thank you 🤝 I will reach out to you soon..."}
                        </p>
                        <p>
                            <button type="submit">Send message!</button>
                        </p>
                    </form>

                </div>
            </div>
            <div className="socialContactDiv">
                <div className="rowDiv">
                    <a className="anchor anchor-link" href="https://www.linkedin.com/in/karthik-reddy-s-92a727b5/" target="_blank">
                        <i className="fa fa-linkedin ilogo" aria-hidden="true"></i>
                        <span className="textSpan">Karthik Reddy Singireddy
                            <i className="fa fa-external-link" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
                <div className="rowDiv">
                    <a className="anchor anchor-link" href="https://medium.com/@karthik.skreddy24" target="_blank">
                        <i className="fa fa-brands fa-medium ilogo" aria-hidden="true"></i>
                        <span className="textSpan">Karthik Reddy Singireddy
                            <i className="fa fa-external-link" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
                <div className="rowDiv">
                    <a className="anchor anchor-link" href="mailto:karthik.skreddy24@gmail.com">
                        <i className="fa fa-envelope ilogo" aria-hidden="true"></i>
                        <span className="textSpan">karthik.skreddy24@gmail.com
                            <i className="fa fa-external-link" aria-hidden="true"></i></span>
                    </a>
                </div>
                <div className="rowDiv">
                    <a className="anchor anchor-link" href="https://twitter.com/KarthikReddyS24" target="_blank">
                        <i className="fa fa-twitter ilogo" aria-hidden="true"></i>
                        <span className="textSpan">Karthik Reddy Singireddy
                            <i className="fa fa-external-link" aria-hidden="true"></i></span>
                    </a>
                </div>
                <div className="rowDiv">
                    <a className="anchor anchor-link" href="https://www.instagram.com/coding_with_karthik/" target="_blank">
                        <i className="fa fa-instagram ilogo" aria-hidden="true"></i>
                        <span className="textSpan">Karthik Reddy S
                            <i className="fa fa-external-link" aria-hidden="true"></i></span>
                    </a>
                </div>
                <div className="rowDiv">
                    <a className="anchor anchor-link" href="https://www.facebook.com/karthikreddy.s.165" target="_blank">
                        <i className="fa fa-facebook ilogo" aria-hidden="true"></i>
                        <span className="textSpan">Karthik Reddy S
                            <i className="fa fa-external-link" aria-hidden="true"></i></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    )
}

export default ContactMe;
